var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-2"},[_c('doughnut-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"plugins":_vm.chartPlugins}}),_c('div',{attrs:{"id":"legend-container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }